<div class="app-study-form-page">
  <app-study-header
    [saveButtonVisible]="true"
    [saveButtonDisabled]="!studyFormChange.isUnsaved"
    [saveButtonLoading]="isSaving"
    [showDispatchButton]="!!study?.lastDispatch"
    [showInvalidMessage]="!studyFormChange.isValid"
    (save)="save()"
  ></app-study-header>
  <div class="scroll-container">
    <app-loading-spinner *ngIf="loading"></app-loading-spinner>
    <div class="page-content" *ngIf="!loading">
      <app-error-snack-bar [message]="errorMessage"></app-error-snack-bar>
      <app-study-dispatch-dialogue
        [dispatch]="study?.lastDispatch"
        [disabled]="studyFormChange.isUnsaved || isSaving"
        (saved)="disptachSaved()"
      ></app-study-dispatch-dialogue>
      <app-study-form
        [study]="study"
        [errorMessage]="errorMessage"
        [disabled]="disabled || isSaving"
        (search)="searchInDocumentExplorer($event)"
        (valueChanges)="onValueChanges($event)"
      ></app-study-form>
    </div>
  </div>
</div>
